import { Component, computed, effect, inject, input } from '@angular/core';
import { LoadingSpinner, Button } from 'excellence-ui';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';
import { DocumentPreview } from '../../../documents/components/document-preview/document-preview';
import { DocumentsStore } from '../../../documents/stores/documents.store';
import { NgIcon } from '@ng-icons/core';
import { DocumentPreviewHeader } from '../../../documents/components/document-preview-header/document-preview-header';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-analysis-lma-preview-page',
  templateUrl: './analysis-lma-preview-page.html',
  imports: [
    DocumentPreview,
    LoadingSpinner,
    ErrorPage,
    Button,
    NgIcon,
    DocumentPreviewHeader,
    RouterLink,
  ],
})
export class AnalysisLmaPreviewPage {
  private documentsStore = inject(DocumentsStore);

  organizationId = input.required<string>();
  documentId = input.required<string>();

  protected document = computed(() => this.documentsStore.allDocuments()[this.documentId()]);

  constructor() {
    effect(() => {
      const documentId = this.documentId();
      const document = this.document();
      if (!document && documentId) {
        this.documentsStore.loadSingle(documentId);
      }
    });
  }
}
